exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changeapp[data-v-5ec8a9c7]{padding-top:20px;padding-right:20px}.changeapp .avatar-uploader .el-upload[data-v-5ec8a9c7]{border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.changeapp .avatar-uploader .el-upload[data-v-5ec8a9c7]:hover{border-color:#409eff}.changeapp .avatar-uploader-icon[data-v-5ec8a9c7]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center;border:1px dashed #d9d9d9}.changeapp .avatar[data-v-5ec8a9c7]{width:100px;height:100px;display:block}\n", ""]);

// exports
